// extracted by mini-css-extract-plugin
export default {"container":"styles_container__V-b8A","container1":"styles_container1__g3Lhp","bg_img":"styles_bg_img__DfdbU","content":"styles_content__stKA3"};